var _path, _path2, _rect, _line, _line2, _line3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneTimeAnprBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1761 23.5272C50.1306 23.3739 50.096 23.2153 50.0734 23.0521C49.9082 21.8597 50.4226 20.7326 51.318 20.0576L51.3005 19.9316C51.2626 19.6581 51.0102 19.4671 50.7367 19.505L21.7096 23.5272H50.1761ZM51.8096 23.5272C51.6817 23.3271 51.594 23.0968 51.5592 22.8462C51.4559 22.1005 51.8535 21.4009 52.4948 21.0872C52.7374 20.9685 52.925 20.7267 52.888 20.4592L52.7864 19.7257C52.6347 18.6316 51.6249 17.8676 50.5308 18.0192L10.6384 23.547C10.3911 23.5812 10.207 23.7926 10.207 24.0422V24.5272C10.207 24.8033 10.4309 25.0272 10.707 25.0272H53.1239C53.3338 25.0272 53.4953 24.8418 53.4665 24.6339C53.4426 24.4616 53.2944 24.3394 53.1239 24.3097C53.1114 24.3075 53.0987 24.3059 53.0859 24.3047C52.765 24.2755 52.4653 24.1555 52.2169 23.9676C52.0573 23.8468 51.9188 23.698 51.8096 23.5272Z",
    fill: "#193232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 25.5039C9.75 24.8135 10.3096 24.2539 11 24.2539H53C53.6904 24.2539 54.25 24.8136 54.25 25.5039V26.7696C53.2912 27.1007 52.601 28.0109 52.601 29.0843C52.601 30.1576 53.2912 31.0678 54.25 31.399V32.5926C53.2912 32.9237 52.601 33.8339 52.601 34.9073C52.601 35.9806 53.2912 36.8908 54.25 37.2219V38.4156C53.2912 38.7467 52.601 39.6569 52.601 40.7303C52.601 41.8036 53.2912 42.7138 54.25 43.0449V44.7959C54.25 45.4862 53.6904 46.0459 53 46.0459H11C10.3096 46.0459 9.75 45.4862 9.75 44.7959V42.9688C10.6063 42.5887 11.2057 41.7303 11.2057 40.7303C11.2057 39.7302 10.6063 38.8718 9.75 38.4917V37.2384C10.7346 36.9218 11.4484 35.9988 11.4484 34.9073C11.4484 33.8157 10.7346 32.8928 9.75 32.5761V31.4154C10.7346 31.0988 11.4484 30.1758 11.4484 29.0843C11.4484 27.9927 10.7346 27.0698 9.75 26.7531V25.5039Z",
    stroke: "#193232",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.6602,
    y: 28.0957,
    width: 31.2504,
    height: 14.2294,
    rx: 2,
    stroke: "#193232"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 41.5273,
    y1: 28.3359,
    x2: 41.5273,
    y2: 41.8934,
    stroke: "#193232",
    strokeLinecap: "square",
    strokeDasharray: "2 3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 22.1172,
    y1: 35.0957,
    x2: 33.7337,
    y2: 35.0957,
    stroke: "#193232",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 22.1172,
    y1: 31.7031,
    x2: 28.8812,
    y2: 31.7031,
    stroke: "#193232",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1172 38.498H33.7337",
    stroke: "#193232",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneTimeAnprBig);
export default __webpack_public_path__ + "static/media/one-time-anpr-big.5c8867501cbbfaebb0f41ac331b958a2.svg";
export { ForwardRef as ReactComponent };